(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],2:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utilities = require('../../assets/src/js/utilities');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RezberryArchive = function (_RezberryClass) {
  _inherits(RezberryArchive, _RezberryClass);

  _createClass(RezberryArchive, [{
    key: 'viewMore',


    /*
    ==========================================================================
    view more
    ==========================================================================
    */
    value: function viewMore(e) {
      e.preventDefault();
      this.page++;
      this.$loading.show();
      this.fetchPosts(this.restBase, {
        cat: this.catFilter,
        tag: this.tagFilter,
        page: this.page
      }, true);
    }

    /*
    ==========================================================================
    fetch posts
    ==========================================================================
    */

  }, {
    key: 'fetchPosts',
    value: function fetchPosts(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var paginate = arguments[2];

      if (Object.keys(params).length > 0) {
        url += '?' + $.param(params);
      }
      $.get(url, function (data, status, xhr) {
        this.totalPages = xhr.getResponseHeader('X-WP-TotalPages');
        this.handleFetchPosts(data, paginate);
      }.bind(this));
    }
  }, {
    key: 'handleFetchPosts',
    value: function handleFetchPosts(data, paginate) {
      if (!data) {
        // TODO: check
        this.$loading.hide();
        return;
      }

      if (this.totalPages > 1 && this.page != this.totalPages) {
        this.show(this.$viewMore);
      } else {
        this.hide(this.$viewMore);
      }

      if (paginate) {
        this.$posts.append(data);
      } else {
        this.$posts.html('').append(data);
      }

      if (!data.length) {
        this.show(this.$noResults);
      } else {
        this.hide(this.$noResults);
      }

      this.$loading.hide();
    }

    /*
    ==========================================================================
    utility
    ==========================================================================
    */

  }, {
    key: 'hide',
    value: function hide(el) {
      el.addClass('d-none');
    }
  }, {
    key: 'show',
    value: function show(el) {
      el.removeClass('d-none');
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }, {
    key: 'selectors',
    get: function get() {
      return {
        noResults: '.t-blog-no-results',
        posts: '.t-blog-posts',
        viewMore: '.t-blog-view-more .btn-wrap'
      };
    }
  }, {
    key: 'listeners',
    get: function get() {
      return {
        '$viewMore': [{
          ev: 'click',
          func: 'viewMore'
        }]
      };
    }
  }]);

  function RezberryArchive(scope) {
    _classCallCheck(this, RezberryArchive);

    // parent methods
    var _this = _possibleConstructorReturn(this, (RezberryArchive.__proto__ || Object.getPrototypeOf(RezberryArchive)).call(this, scope));

    _this.addSelectors();
    _this.addListeners();

    var urlParts = window.location.pathname.split('/');
    if (urlParts[2] !== '') {
      _this.catFilter = urlParts[2];
    }
    if (urlParts[2] == 'tag') {
      _this.tagFilter = urlParts[3];
    }

    _this.$loading = $('.loading');
    _this.page = 1;
    _this.restBase = '/wp-json/rez/posts';
    _this.totalPages = 0;
    return _this;
  }

  return RezberryArchive;
}(_utilities.RezberryClass);

$(document).ready(function () {
  new RezberryArchive('.t-blog');
});

},{"../../assets/src/js/utilities":1}]},{},[2]);
